import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { callCommandBeforeEditorView } from '@milkdown/exception';
import { createContainer, createSlice } from '../context';
import { createTimer } from '../timing';
import { getAtom } from '../utility';
import { editorViewCtx, EditorViewReady } from './editor-view';
import { marksCtx, nodesCtx, schemaCtx, SchemaReady } from './schema';
export const createCmd = (key, value) => [key, value];
export const commandsCtx = createSlice({}, 'commands');
export const createCmdKey = () => createSlice((() => () => false), 'cmdKey');
export const commandsTimerCtx = createSlice([], 'commandsTimer');
export const CommandsReady = createTimer('KeymapReady');
export const commands = (pre) => {
    const container = createContainer();
    const commandManager = {
        create: (slice, value) => slice(container.sliceMap, value),
        get: (slice) => container.getSlice(slice).get(),
        call: () => {
            throw callCommandBeforeEditorView();
        },
    };
    pre.inject(commandsCtx, commandManager).inject(commandsTimerCtx, [SchemaReady]).record(CommandsReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(commandsTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const schema = ctx.get(schemaCtx);
        const getCommands = (atoms, isNode) => atoms
            .map((x) => [getAtom(x.id, schema, isNode), x.commands])
            .map(([atom, commands]) => atom && (commands === null || commands === void 0 ? void 0 : commands(atom, schema)))
            .filter((x) => !!x)
            .flat();
        const commands = [...getCommands(nodes, true), ...getCommands(marks, false)];
        const commandManager = ctx.get(commandsCtx);
        commands.forEach(([key, command]) => {
            commandManager.create(key, command);
        });
        ctx.done(CommandsReady);
        yield ctx.wait(EditorViewReady);
        ctx.update(commandsCtx, (prev) => (Object.assign(Object.assign({}, prev), { call: (meta, info) => {
                const cmd = commandManager.get(meta);
                const command = cmd(info);
                const view = ctx.get(editorViewCtx);
                return command(view.state, view.dispatch, view);
            } })));
    });
};
//# sourceMappingURL=commands.js.map